// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingTrustIndicator_root__PLPnd","text":"ListingTrustIndicator_text__S3v_R"};